import React, { useEffect } from "react";
import "./pillars.css";
import Aos from "aos";
import "aos/dist/aos.css";
import PillarIcon from '../../assets/pillar_icon.webp'

export default function Pillars() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div className="pillars-section">
      <div className="pillars-left" data-aos="fade-right">
        <h3 data-aos="fade-in" data-aos-duration="1000">
          <span className="large-circle"></span>FUTURE FIRST 2.0
        </h3>

        <h1
          data-aos="fade-in"
          data-aos-duration="1000"
        >
          Our Sustainability Roadmap <span className='title-second-color'>(2026 – 2030)</span>
        </h1>


        <div className="pillars-content-main-container">
          <div className="pillars-content-sub-container pillars-content-sub-image-container">
            <img src={PillarIcon} alt="" />
          </div>
          <div className="pillars-content-sub-container">
            <p
              data-aos="fade-in"
              data-aos-duration="1000"
              className='pillars-p'
            >
              <p>
                As we concluded our first five-year sustainability journey in 2025,
                Future First 2.0 marks the next phase of our commitment.
                Building on the foundation of Future First 2025, this renewed roadmap
                brings clearer focus, sharper targets and deeper integration across our operations.
              </p>
              <p>
                Guided by one purpose, Future First 2.0 strengthens how we protect the planet and
                empower our people, ensuring we continue to create meaningful, measurable impact across our footprint.
              </p>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
